/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Size_Stage_ScentingInputs */

const vi_lot_size_stage_scenting = /** @type {(inputs: Lot_Size_Stage_ScentingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô lấy hương`)
};

/**

* @param {Lot_Size_Stage_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_size_stage_scenting = /** @type {((inputs?: Lot_Size_Stage_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Size_Stage_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_size_stage_scenting(inputs)
});